import React from 'react';
import { Paper, Box } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import OcurrencesDataTableV2 from '../SharedComponents/OcurrencesDataTableV2';
import OcurrencesHeader from '../SharedComponents/OcurrencesHeader';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    paperRoot: {
        overflow: 'hidden',
        backgroundColor: ({ bgcolor }) => (bgcolor ? bgcolor : 'rgba(0, 0, 0, 0)'),
        paddingTop: '0.5rem',
    },
}));

const OcurrencesDataRenderV2 = ({ bgcolor, label, icon, extraColumns = [], error = '', loadData }) => {
    const classes = useStyles({ bgcolor });

    return (
        <Paper classes={{ root: classes.paperRoot }}>
            <Box className={classes.root} ml={2}>
                <OcurrencesHeader title={label} icon={icon} size={20} />
            </Box>

            <Box p={2}>
                {error ? (
                    <Box mb={2}>
                        <Alert severity="error">{error}</Alert>
                    </Box>
                ) : null}

                <OcurrencesDataTableV2 loadData={loadData} extraColumns={extraColumns} />
            </Box>
        </Paper>
    );
};

export default OcurrencesDataRenderV2;